import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { PromptCreateService } from '../../services/prompt-create.service';
// import { Subscription } from 'rxjs';
import { MatButtonModule } from '@angular/material/button';
import { ButtonComponent } from '../common/components/button/button.component';


@Component({
  selector: 'app-polling-dialog',
  standalone: true,
  imports: [MatDialogModule,CommonModule,MatProgressSpinnerModule,MatButtonModule,ButtonComponent],
  templateUrl: './polling-dialog.component.html',
  styleUrl: './polling-dialog.component.scss'
})
export class PollingDialogComponent {

  receivedData: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<PollingDialogComponent>,
    private promptCreateService: PromptCreateService,
  ){
    
  }

  ngOnInit() {
    this.promptCreateService.data$.subscribe((data:any) => {
      this.receivedData = data;
    });
  }

  close() {
    this.dialogRef.close();
    this.promptCreateService.updateData(false);
  }

  ngOnDestroy() {
  }

}
